import React from "react";

import { getIndexedInvoiceTaskProgress } from "../../utils/invoiceTaskUtils";

export default function JobTaskProgress({ source = {}, compact = false }) {
	const progress = getIndexedInvoiceTaskProgress(source);
	if (!progress) {
		return null;
	}

	const progressColor = progress.isComplete ? "#15803d" : "#3478f5";
	return (
		<div style={{ width: compact ? 145 : 180, maxWidth: "100%", marginTop: compact ? 4 : 6 }} title={progress.ariaLabel}>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, color: progress.isComplete ? "#166534" : "#315c91", fontSize: compact ? 9 : 10, fontWeight: 800 }}>
				<span>{progress.label}</span>
				<span>{progress.percent}%</span>
			</div>
			<div
				role="progressbar"
				aria-label={progress.ariaLabel}
				aria-valuemin={0}
				aria-valuemax={progress.total}
				aria-valuenow={progress.completed}
				style={{ height: compact ? 4 : 5, marginTop: 3, overflow: "hidden", borderRadius: 999, backgroundColor: "#dbe4ef" }}
			>
				<div style={{ width: `${progress.percent}%`, height: "100%", borderRadius: 999, backgroundColor: progressColor, transition: "width .2s ease" }} />
			</div>
		</div>
	);
}
